import { RegionShared } from "@1games-ru/region-shared";
import { Phase } from "@1games-ru/region-shared/dist/enums/death/phase";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class DeathScreenMpProvider {
  public static async timeExpired(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.DeathTimeExpiredResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      undefined,
      typeof RegionShared.Backend.Responses.DeathTimeExpiredResponse
    >(RegionShared.Backend.Events.Death.TimeExpired, undefined);
  }

  public static async waitAmbulance(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.DeathWaitAmbulanceResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      undefined,
      typeof RegionShared.Backend.Responses.DeathWaitAmbulanceResponse
    >(RegionShared.Backend.Events.Death.WaitAmbulance, undefined);
  }

  public static async setPhase(
    phase: Phase,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.DeathSetPhaseResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.DeathSetPhaseRequest,
      typeof RegionShared.Backend.Responses.DeathSetPhaseResponse
    >(RegionShared.Backend.Events.Death.SetPhase, phase);
  }

  public static async toHospital(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.DeathToHospitalResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      undefined,
      typeof RegionShared.Backend.Responses.DeathToHospitalResponse
    >(RegionShared.Backend.Events.Death.ToHospital, undefined);
  }

  public static async getAntiShock(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.DeathGetAntiShockResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      undefined,
      typeof RegionShared.Backend.Responses.DeathGetAntiShockResponse
    >(RegionShared.Backend.Events.Death.GetAntiShock, undefined);
  }
}
